type PaginationConfig = {
    page: number;
    limit: number;
    onRangeChange?: (from: number, to: number) => void;
    onPageChange?: (page: number) => void;
};

export function paginate({ page, limit, onRangeChange, onPageChange }: PaginationConfig) {
    const from = Math.max(Math.ceil((page - 1) * limit), 0);
    const to = Math.max(Math.ceil(page * limit), limit);

    if (onPageChange) {
        onPageChange(page);
    }

    if (onRangeChange) {
        onRangeChange(from, to);
    }

    return { from, to };
}  